module.exports = __webpack_public_path__ + "static/media/login-img.4b2915fa.png";